import { useState, useEffect, useCallback } from "react";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";

export function usePipelineConfigs() {
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [featureGated, setFeatureGated] = useState(false);

  const { user } = useAuth();
  const companyId = user?.companyId;

  const fetchConfigs = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    setError(null);

    try {
      const res = await makeApiRequest(
        "get",
        apiRoutes.getPipelineConfigs,
        { id: user.id, accessToken: user.accessToken },
        companyId
      );
      setConfigs(res.data?.data ?? res.data ?? []);
      setFeatureGated(false);
    } catch (err) {
      if (err.response?.status === 403) {
        setFeatureGated(true);
      } else {
        setError(err);
      }
    } finally {
      setLoading(false);
    }
  }, [companyId, user?.id, user?.accessToken]);

  useEffect(() => {
    fetchConfigs();
  }, [fetchConfigs]);

  return { configs, loading, error, featureGated, refetch: fetchConfigs };
}
